export default {"src":"/_next/static/media/MonthlySipStatus.bf0b08e2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};